import { render, staticRenderFns } from "./AuthStatus.vue?vue&type=template&id=3c79bd6a&scoped=true"
import script from "./AuthStatus.vue?vue&type=script&lang=js"
export * from "./AuthStatus.vue?vue&type=script&lang=js"
import style0 from "./AuthStatus.vue?vue&type=style&index=0&id=3c79bd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79bd6a",
  null
  
)

export default component.exports